var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitterinline = function SvgTwitterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    fill: "#0D92F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.41 75c18.492 0 28.604-15.388 28.604-28.731 0-.437-.01-.872-.029-1.305A20.496 20.496 0 0 0 77 39.734a19.975 19.975 0 0 1-5.773 1.59 10.128 10.128 0 0 0 4.42-5.585 20.11 20.11 0 0 1-6.383 2.451A10.02 10.02 0 0 0 61.926 35c-5.552 0-10.054 4.522-10.054 10.096 0 .793.088 1.564.26 2.303-8.355-.422-15.764-4.44-20.722-10.55a10.105 10.105 0 0 0-1.361 5.075c0 3.503 1.774 6.596 4.473 8.406a9.946 9.946 0 0 1-4.553-1.264l-.001.13c0 4.89 3.465 8.973 8.065 9.898a10.023 10.023 0 0 1-4.54.173c1.28 4.013 4.991 6.932 9.391 7.014a20.111 20.111 0 0 1-12.486 4.322c-.81 0-1.611-.046-2.398-.14A28.366 28.366 0 0 0 43.41 75",
    fill: "#fff"
  })));
};
export default SvgTwitterinline;